import {getApi} from './../core/index';

export function lv1(language, params, apiKey = null) {
    return getApi(language, params, '/restaurant/shifts/lv1', apiKey);
}

export function lv2(language, params, apiKey = null) {
    return getApi(language, params, '/restaurant/shifts/lv2', apiKey);
}

export function lv3(language, params, apiKey = null) {
    return getApi(language, params, '/restaurant/shifts/lv3', apiKey);
}
